import script from "./ScheduleCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleCarousel.vue?vue&type=style&index=0&id=8ff9e854&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff9e854"]])

export default __exports__